import { render } from "./PowerCheck.vue?vue&type=template&id=afa22c72&scoped=true&ts=true"
import script from "./PowerCheck.vue?vue&type=script&lang=ts"
export * from "./PowerCheck.vue?vue&type=script&lang=ts"

import "./PowerCheck.vue?vue&type=style&index=0&id=afa22c72&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa22c72"]])

export default __exports__